import React from 'react';

const OurLocation = () => {
    const location = {
        name: "Cemara Jaya Vallas",
        address: "Jalan Boulevard Raya no 8 AM, Kompleks Cemara Asri",
        phone: "+62-821-7820-8800",
        email: "contact@cemaravalas.com",
        businessHours: [
            "Monday - Friday: 9:00 AM - 6:00 PM",
            "Saturday: 10:00 AM - 4:00 PM",
            "Sunday: Closed"
        ]
    };
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h2 className="text-center mb-4">Our Location</h2>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="single-input">
                        <label>Contact Information</label>
                        <div style={{ padding: '20px 0' }}>
                            <p><strong>Address:</strong> {location.address}</p>
                            <p><strong>Phone:</strong> {location.phone}</p>
                            <p><strong>Email:</strong> {location.email}</p>
                            <div>
                                <strong>Business Hours:</strong>
                                <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                                    {location.businessHours.map((hours, index) => (
                                        <li key={index}>{hours}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="single-input">
                        <label>Find Us on Map</label>
                        <div className="map-wrapper" style={{ marginTop: '15px' }}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d497.7259048561993!2d98.70700305298341!3d3.6314439000000025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x303133cd986b5db9%3A0xb64fa3dafbaf58f0!2sJl.%20Boulevard%20Raya%20No.8am%2C%20Medan%20Estate%2C%20Kec.%20Percut%20Sei%20Tuan%2C%20Kabupaten%20Deli%20Serdang%2C%20Sumatera%20Utara%2020221!5e0!3m2!1sen!2sid!4v1766822299447!5m2!1sen!2sid"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Our Location Map"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="btn-area text-center" style={{ marginTop: '30px' }}>
                        <button
                            className="cmn-btn"
                            onClick={() => window.open('https://maps.google.com/maps?daddr=Jl.+Boulevard+Raya+No.8am,+Medan+Estate,+Kec.+Percut+Sei+Tuan,+Kabupaten+Deli+Serdang,+Sumatera+Utara+20221', '_blank')}
                        >
                            Get Directions
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurLocation;